import React, { createContext, useState } from "react";

import _ from "lodash";
import axios from "axios";

import Utils from "./Utils";

import md5 from "md5";

const UserContext = createContext();

const UserProvider = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [showPlan, setShowPlan] = useState(false);

  const goLogin = ({ email, password }, callback) => {
    axios
      .post(Utils.apiUrl("auth/login"), `&email=${email}&password=${md5(password)}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUserData(res.data);
          Utils.setUserData(res.data);
        }
        window.setTimeout(() => callback(res.data.success, res.data.message), 1000);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };
  const goImpersonate = ({ email }, callback) => {
    axios
      .post(Utils.apiUrl("auth/impersonate"), `&email=${email}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUserData(res.data);
          Utils.setUserData(res.data);
        }
        window.setTimeout(() => callback(res.data.success, res.data.message), 1000);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const goFrgpwd = (data, callback) => {
    var postdata = `email=${data.email}`;

    if (_.get(data, "otp", false)) {
      postdata += `&otp=${data.otp}`;
      postdata += `&new_password=${md5(data.new_password)}`;
    }

    axios
      .post(Utils.apiUrl("auth/frgpwd"), postdata, Utils.apiHeaders())
      .then((res) => {
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const changePassword = (data, callback) => {
    axios
      .post(Utils.apiUrl("auth/changepwd"), data, Utils.apiHeaders())
      .then((res) => {
        // if(res.data.success === false){
        //   Utils.removeSession();
        //   window.location.href = process.env.PUBLIC_URL + '/login';
        //   return;
        // }
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const saveProfile = (data, callback) => {
    axios
      .post(Utils.apiUrl("auth/saveprofile"), data, Utils.apiHeaders())
      .then((res) => {
        // if(res.data.success === false){
        //   Utils.removeSession();
        //   window.location.href = process.env.PUBLIC_URL + '/login';
        //   return;
        // }
        if (res.data.success) {
          setUserData(res.data.data);
          Utils.setUserData(res.data);
        }
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const addToUserData = (data, callback = null) => {
    setUserData({ ...userData, ...data });
    Utils.addToUserData(data);
    if (callback) callback();
  };

  const goTraining = () => {
    return axios.get(Utils.apiUrl("auth/gotraining"), Utils.apiHeaders()).then((res) => {
      if (_.get(res, "data.learnerId", false)) {
        addToUserData({ learnerId: res.data.learnerId });
      }
      if (_.get(res, "data.redirecturl", false)) {
        window.open(res.data.redirecturl);
      }
      return res.data;
    });
  };

  const logoutTraining = () => {
    if (_.get(userData, "learnerId", false)) {
      return axios.get(Utils.apiUrl(`auth/logout/${userData.learnerId}`), Utils.apiHeaders());
    } else {
      return new Promise((resolve, reject) => {
        resolve({ data: { success: true } });
      });
    }
  };

  const logout = (callback) => {
    logoutTraining()
      .then((res) => {
        if (res.data.success) {
          setUserData(false);
          Utils.setUserData(false);
        }
        callback();
      })
      .catch((err) => {
        console.log(err);
        callback();
      });
  };

  const getHelpVideos = () => {
    return axios.get(Utils.apiUrl("resources/fetchhvs"), Utils.apiHeaders()).then((res) => {
      return res.data.success ? res.data.mods : [];
    });
  };

  return (
    <UserContext.Provider value={{ userData, addToUserData, saveProfile, goLogin, goImpersonate, goFrgpwd, goTraining, logout, changePassword, getHelpVideos, showPlan, setShowPlan }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };
